<template>
  <div class="config-container">
    <div class="config-header">
      <h2 class="config-title">Datos de la Empresa</h2>
      <p class="config-subtitle">Información del gimnasio visible en documentos y reportes</p>
    </div>

    <div v-if="cargando" class="estado-carga">
      <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
    </div>

    <form v-else @submit.prevent="guardar" class="config-form">

      <!-- Logo -->
      <div class="seccion-logo">
        <div class="logo-preview" @click="$refs.inputLogo.click()">
          <img v-if="logoUrl" :src="logoUrl" alt="Logo" class="logo-img" />
          <div v-else class="logo-placeholder">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" class="logo-icon">
              <rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/>
              <polyline points="21 15 16 10 5 21"/>
            </svg>
            <span>Subir logo</span>
          </div>
        </div>
        <input ref="inputLogo" type="file" accept="image/png,image/jpeg,image/webp" style="display:none" @change="onLogo" />
        <p class="logo-hint">PNG, JPG o WEBP · máx 5 MB · clic para cambiar</p>
      </div>

      <!-- Campos -->
      <div class="campos-grid">
        <div class="campo">
          <label>Nombre / Razón Social</label>
          <input v-model="datos.Nombre" type="text" placeholder="Ej: Gym Élite S.A." maxlength="32" />
        </div>
        <div class="campo">
          <label>Nombre Comercial</label>
          <input v-model="datos.RazonSocial" type="text" placeholder="Ej: Gym Élite" maxlength="45" />
        </div>
        <div class="campo">
          <label>Representante Legal</label>
          <input v-model="datos.RepresentanteLegal" type="text" placeholder="Ej: Juan Pérez" maxlength="45" />
        </div>
        <div class="campo">
          <label>RUC <span class="campo-readonly-tag">solo lectura</span></label>
          <input v-model="datos.RUC" type="text" readonly class="readonly" maxlength="13" />
        </div>
        <div class="campo">
          <label>Teléfono</label>
          <input v-model="datos.Telefono" type="tel" placeholder="Ej: 042-123-456" maxlength="12" />
        </div>
        <div class="campo">
          <label>Celular</label>
          <input v-model="datos.Celular" type="tel" placeholder="Ej: 0999-999-999" maxlength="13" />
        </div>
        <div class="campo">
          <label>Email</label>
          <input v-model="datos.email" type="email" placeholder="Ej: info@gimnasio.com" maxlength="45" />
        </div>
        <div class="campo">
          <label>Sitio Web</label>
          <input v-model="datos.sitioWeb" type="text" placeholder="Ej: www.gimnasio.com" maxlength="45" />
        </div>
        <div class="campo campo-full">
          <label>Dirección</label>
          <input v-model="datos.direccion" type="text" placeholder="Ej: Av. Principal 123, Guayaquil" maxlength="512" />
        </div>
        <div class="campo campo-check">
          <label class="check-label">
            <input type="checkbox" v-model="datos.obligado_contabilidad" true-value="SI" false-value="NO" />
            Obligado a llevar contabilidad
          </label>
        </div>
        <div class="campo campo-check">
          <label class="check-label">
            <input type="checkbox" v-model="datos.rimpe" true-value="SI" false-value="NO" />
            Régimen RIMPE
          </label>
        </div>
        <div class="campo campo-full" v-if="datos.rimpe === 'SI'">
          <label>Leyenda RIMPE</label>
          <input v-model="datos.leyenda_rimpe" type="text" maxlength="45" placeholder="Ej: CONTRIBUYENTE RÉGIMEN RIMPE" />
        </div>
      </div>

      <!-- Acciones -->
      <div class="config-acciones">
        <span v-if="mensajeGuardado" :class="['feedback', mensajeGuardado.tipo]">
          {{ mensajeGuardado.texto }}
        </span>
        <button type="submit" class="btn-guardar" :disabled="guardando">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" class="btn-icon">
            <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2zM17 21v-8H7v8M7 3v5h8"/>
          </svg>
          {{ guardando ? 'Guardando...' : 'Guardar cambios' }}
        </button>
      </div>

    </form>

    <v-snackbar v-model="mostrarMensaje" :timeout="3000" :color="mensaje.color" top>
      {{ mensaje.texto }}
    </v-snackbar>
  </div>
</template>

<script>
import ApiService from '../../Servicios/ApiService'

const LS_KEY = 'empresa_datos'

export default {
  name: 'ConfiguracionComponent',
  data: () => ({
    cargando: true,
    guardando: false,
    logoUrl: null,
    logoBase64: null,
    datos: {
      Nombre: '', RazonSocial: '', RepresentanteLegal: '',
      RUC: '', Telefono: '', Celular: '', email: '',
      sitioWeb: '', direccion: '',
      obligado_contabilidad: 'NO', rimpe: 'NO', leyenda_rimpe: null
    },
    mensajeGuardado: null,
    mostrarMensaje: false,
    mensaje: { texto: '', color: '' }
  }),

  async mounted () {
    await this.cargarDatos()
  },

  methods: {
    async cargarDatos () {
      this.cargando = true
      try {
        const res    = await ApiService.get('api/empresa/datos')
        this.datos   = { ...this.datos, ...res }
        this.logoUrl = res.logo || null
      } catch (err) {
        console.error('Error al cargar datos de empresa:', err)
        // fallback localStorage mientras se resuelve conectividad
        const local = localStorage.getItem(LS_KEY)
        if (local) {
          const parsed = JSON.parse(local)
          this.datos   = { ...this.datos, ...parsed }
          this.logoUrl = parsed.logo || null
        }
      } finally {
        this.cargando = false
      }
    },

    onLogo (e) {
      const file = e.target.files[0]
      if (!file) return
      if (file.size > 5000000) {
        alert('La imagen debe pesar menos de 5 MB')
        return
      }
      const reader = new FileReader()
      reader.onload = ev => {
        this.logoUrl    = ev.target.result
        this.logoBase64 = ev.target.result
      }
      reader.readAsDataURL(file)
    },

    async guardar () {
      this.guardando = true
      this.mensajeGuardado = null
      const payload = { ...this.datos }
      if (this.logoBase64) payload.logo = this.logoBase64
      delete payload.RUC      // nunca enviar RUC
      delete payload.idEmpresa

      try {
        await ApiService.put('api/empresa/datos', payload)
        localStorage.setItem(LS_KEY, JSON.stringify({ ...this.datos, logo: this.logoUrl }))
        this.mensajeGuardado = { tipo: 'exito', texto: '✓ Datos guardados correctamente' }
      } catch (err) {
        console.error('Error al guardar datos de empresa:', err)
        const msg = err.response && err.response.data && err.response.data.mensaje
        this.mensajeGuardado = { tipo: 'error', texto: msg || 'Error al guardar. Intente de nuevo.' }
      } finally {
        this.guardando = false
        setTimeout(() => { this.mensajeGuardado = null }, 4000)
      }
    }
  }
}
</script>

<style scoped>
.config-container {
  max-width: 820px;
  margin: 30px auto;
  padding: 32px;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 16px;
  box-shadow: var(--shadow-md);
}

.config-header {
  margin-bottom: 32px;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--color-border);
}

.config-title {
  font-size: 1.6rem;
  font-weight: 700;
  color: var(--color-primary);
  margin: 0 0 6px;
}

.config-subtitle {
  color: var(--color-text-secondary);
  font-size: 0.9rem;
  margin: 0;
}

.estado-carga {
  display: flex;
  justify-content: center;
  padding: 60px 0;
}

/* Logo */
.seccion-logo {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin-bottom: 32px;
}

.logo-preview {
  width: 140px;
  height: 140px;
  border-radius: 12px;
  border: 2px dashed var(--color-border);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
  transition: border-color 0.2s;
  background: var(--color-surface-2);
}

.logo-preview:hover { border-color: var(--color-primary); }

.logo-img { width: 100%; height: 100%; object-fit: contain; }

.logo-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: var(--color-text-muted);
  font-size: 0.85rem;
}

.logo-icon { width: 36px; height: 36px; }

.logo-hint { font-size: 0.78rem; color: var(--color-text-muted); margin: 0; }

/* Campos */
.campos-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 28px;
}

.campo { display: flex; flex-direction: column; gap: 6px; }
.campo-full { grid-column: 1 / -1; }

.campo label {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--color-text-secondary);
}

.campo input {
  padding: 12px 14px;
  border-radius: 8px;
  border: 1px solid var(--color-border);
  background: var(--color-surface-2);
  color: var(--color-text-primary);
  font-size: 0.95rem;
  transition: border-color 0.2s;
  outline: none;
}

.campo input:focus { border-color: var(--color-primary); box-shadow: 0 0 0 3px rgba(19,236,19,0.12); }

.campo input.readonly {
  opacity: 0.5;
  cursor: not-allowed;
  border-style: dashed;
}

.campo-readonly-tag {
  font-size: 0.7rem;
  color: var(--color-text-muted);
  background: var(--color-surface-2);
  border: 1px solid var(--color-border);
  border-radius: 4px;
  padding: 1px 5px;
  margin-left: 6px;
  vertical-align: middle;
}

.campo-check {
  display: flex;
  align-items: center;
}

.check-label {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.9rem;
  color: var(--color-text-primary);
  cursor: pointer;
}

.check-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  accent-color: var(--color-primary);
  cursor: pointer;
}

/* Acciones */
.config-acciones {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  padding-top: 20px;
  border-top: 1px solid var(--color-border);
}

.feedback {
  font-size: 0.85rem;
  font-weight: 500;
}
.feedback.exito { color: var(--color-primary); }
.feedback.aviso { color: var(--color-warning); }
.feedback.error { color: var(--color-error); }

.btn-guardar {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: var(--color-primary);
  color: var(--color-bg);
  border: none;
  border-radius: 10px;
  font-weight: 700;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: var(--shadow-glow);
}

.btn-guardar:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(19,236,19,0.3);
}

.btn-guardar:disabled { opacity: 0.6; cursor: not-allowed; }

.btn-icon { width: 18px; height: 18px; }

@media (max-width: 600px) {
  .config-container { padding: 20px; margin: 16px; }
  .campos-grid { grid-template-columns: 1fr; }
  .campo-full { grid-column: 1; }
}
</style>



// WEBPACK FOOTER //
// src/components/Configuracion/ConfiguracionComponent.vue